import React from "react";

// Small brand mono eyebrow label.
export function Eyebrow({ children, className = "", style }) {
  return (
    <div className={`eyebrow ${className}`} style={style}>{children}</div>
  );
}

// Numbered section header used across the client dashboard.
export function SectionHead({ n, title, hint, brand = "#E05A2C", muted = "#857C72", ink = "#FAF7F2" }) {
  return (
    <div className="flex items-baseline gap-3 mb-5">
      <span className="font-mono text-sm" style={{ color: brand }}>{n}</span>
      <div>
        <h3 className="font-display text-lg md:text-xl uppercase" style={{ color: ink }}>{title}</h3>
        {hint ? <p className="text-sm mt-1" style={{ color: muted }}>{hint}</p> : null}
      </div>
    </div>
  );
}

// Primary orange CTA with a pulsing glow halo behind it.
export function PrimaryButton({ children, className = "", glow = true, ...props }) {
  return (
    <div className="relative inline-flex">
      {glow && (
        <span aria-hidden className="cta-pulse absolute inset-0 rounded-full bg-[#E05A2C] blur-lg -z-0" />
      )}
      <button
        {...props}
        className={`relative z-10 rounded-full bg-[#E05A2C] px-7 py-3 font-medium text-white transition-all duration-200 hover:bg-[#F26B3A] disabled:opacity-60 disabled:cursor-not-allowed ${className}`}
      >
        {children}
      </button>
    </div>
  );
}

// Delta chip: coloured by direction (up = brand/gold, down = muted red).
export function Delta({ delta, className = "" }) {
  if (!delta || delta.dir === "none") return null;
  const color = delta.dir === "up" ? "#4F9D69" : delta.dir === "down" ? "#E0693C" : "#857C72";
  return (
    <span className={`font-mono text-xs ${className}`} style={{ color }}>{delta.text}</span>
  );
}
